<template>
  <b-modal id="alertsModal" title="Alerty" scrollable centered size="lg" :hide-footer="true" :header-class="'pt-4 align-items-center'" :header-border-variant="'light'" :body-class="'d-flex'">
    <template #modal-header>
      <div class="d-flex px-4">
        <h6 class="mb-0">{{$t('global.alerts')}}</h6>
        <h6 v-if="alertsCount() > 0" class="mb-0 mx-4">[<span class="text-danger text-lowercase">{{ alertsCriticalCount() }} {{ $t('global.alerts_critical')}}</span> / <span class="text-warning text-lowercase">{{ alertWarningsCount() }} {{ $t('global.alerts_informative')}}</span>]</h6>
        <h6 v-else class="mx-4 mb-0">[<span class="text-green">{{ 0 }}</span>]</h6>
      </div>
      <button class="btn btn-gray btn-close mr-4" @click="hideModal"><x-icon></x-icon></button>
    </template>
    <div class="px-4 w-100">
      <alert-type-summary :name="$t('global.project')" :id="'project'" :data="this.alertsData.project"></alert-type-summary>
      <alert-type-summary :name="$t('global.sources')" :id="'source'" :data="this.alertsData.source" :sources="this.sourcesData"></alert-type-summary>
      <alert-type-summary :name="$t('global.feeds')" :id="'feed'" :data="this.alertsData.feed"></alert-type-summary>
    </div>
  </b-modal>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
import AlertTypeSummary from './Alert/AlertTypeSummary'

export default {
  name: 'AlertsModal',

  data () {
    return {
      //
    }
  },

  props: {
    alertsData: { required: false, type: Object },
    sourcesData: { required: false, type: Array }
  },

  methods: {
    showModal () {
      window.dataLayer.push({ event: 'viewMoreAlerts' })
    },

    hideModal () {
      this.$root.$emit('bv::hide::modal', 'alertsModal')
    },

    alertsCount () {
      return this.alertsData.feed.length + this.alertsData.source.length + this.alertsData.project.length
    },

    alertsCriticalCount () {
      return this.alertsData.feed.filter(alert => alert.level === 0).length + this.alertsData.source.filter(alert => alert.level === 0).length + this.alertsData.project.filter(alert => alert.level === 0).length
    },

    alertWarningsCount () {
      return this.alertsData.feed.filter(alert => alert.level === 1).length + this.alertsData.source.filter(alert => alert.level === 1).length + this.alertsData.project.filter(alert => alert.level === 1).length
    }
  },

  components: { AlertTypeSummary, XIcon }
}
</script>
